export default __webpack_public_path__ + "static/media/vat-unpaid.dfa5a92d.svg";